import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../instance";

const url = process.env.REACT_APP_API_BASE_URL;

const initialState = { 
  staffstaffloading: false,
  
};

export const deleteCoBranch = createAsyncThunk(
  "staffSettingSlice/deleteCoBranch",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/hr/deleteCoBranch.action?coBranchid_id=${data?.coBranchid_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteLeaveApp = createAsyncThunk(
  "staffSettingSlice/deleteLeaveApp",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/self/deleteLeaveApp.action?laId_id=${data?.laId_id}`)
      .then((res) => res.data);
    return res;
  }
);

export const deleteShiftRequest = createAsyncThunk(
  "staffSettingSlice/deleteShiftRequest",
  async (data) => {
    const res = await axiosInstance
      .get(`${url}/self/deleteShiftRequest.action?shrId=${data?.shrId}`)
      .then((res) => res.data);
    return res;
  }
);


export const staffSettingSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    clearStaffObj: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder 
      .addCase(deleteCoBranch.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteCoBranch.fulfilled, (state,action) => {
        state.staffloading = false;
      })
      .addCase(deleteCoBranch.rejected, (state) => {
        state.staffloading = false;
      }) 
       
      .addCase(deleteLeaveApp.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteLeaveApp.fulfilled, (state,action) => {
        state.staffloading = false;
      })
      .addCase(deleteLeaveApp.rejected, (state) => {
        state.staffloading = false;
      }) 

      .addCase(deleteShiftRequest.pending, (state) => {
        state.staffloading = true;
      })
      .addCase(deleteShiftRequest.fulfilled, (state,action) => {
        state.staffloading = false;
      })
      .addCase(deleteShiftRequest.rejected, (state) => {
        state.staffloading = false;
      }) 

      
  },
});

export default staffSettingSlice.reducer;
export const {
  setGraduateHeaderObj,
  graduateCleanUp,
  setGraduateListObj,
  setGraduateObj,
  setGradUpload,
  clearStaffObj,
} = staffSettingSlice.actions;
